module.exports = __webpack_public_path__ + "static/media/btg_06.d0af5c65.png";